<a class="redirect-link truncate" [title]="linkLabel()" [attr.href]="redirectLink()" target="_blank">
  <span class="redirect-link__text truncate">{{ linkLabel() }}</span>
  @if (redirectLink()) {
    <mat-icon class="redirect-link__icon material-icons-outlined">north_east</mat-icon>
  }
</a>
